//字典
export const dataDictionaryUrl = '/app/data-dictionary'
export const getAllDataDictionary = (version) => `${dataDictionaryUrl}/cache?version=${version}`
export const getDataDictionaryPage = () => `${dataDictionaryUrl}/paging-list`
export const createDataDictionary = () => `${dataDictionaryUrl}`
export const deleteDataDictionary = (id) => `${dataDictionaryUrl}/data-dictionary-type?id=${id}`
export const updateDataDictionary = () => `${dataDictionaryUrl}`

//字典明细
export const getDataDictionaryPageDetail = () => `${dataDictionaryUrl}/paging-detail-list`
export const createDataDictionaryDetail = () => `${dataDictionaryUrl}/detail`
export const deleteDataDictionaryDetail = (dataDictionaryId, dataDictionayDetailId) => `${dataDictionaryUrl}?dataDictionaryId=${dataDictionaryId}&dataDictionayDetailId=${dataDictionayDetailId}`
export const updateDataDictionaryDetail = () => `${dataDictionaryUrl}/detail`
export const updateDataDictionaryStatus = () => `${dataDictionaryUrl}/set-status`
